import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {useGame} from '../contexts/GameContext';
import Ticket from './Ticket';
import CalledNumbers from './CalledNumbers';
import PlayersList from './PlayersList';
import Actions from "./actions";
import ErrorNotification from "./notification/error";
import PrizeWinner from "./prizeWinner";

const GameContainer = styled.div<{ windowHeight?: number }>`
    position: relative;
    height: ${({windowHeight}) => (windowHeight ? `${windowHeight}px` : '100vh')};
    width: 100vw;
    padding: 20px;
    background: url("./bg.svg") center center/cover no-repeat;
    background-color: #EF2152;
    display: flex;
    flex-direction: column;
    justify-content: center;

    flex: 0 0 auto;

`;

const GameControls = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 20px 0;
`;

const Button = styled.button<{ primary?: boolean }>`
    padding: 10px 20px;
    border-radius: 25px;
    border: none;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    background: ${props => props.primary ? '#4CAF50' : '#fff'};
    color: ${props => props.primary ? '#fff' : '#333'};

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }
`;

const Game: React.FC = () => {
    const {room, errorMessage, errorCategory} = useGame();
    const [windowHeight, setWindowHeight] = useState<number>(window.innerHeight);
    const [countdown, setCountdown] = useState(3);
    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    useEffect(() => {
        if (errorMessage) {
            setShowNotificationModal(true);

            // Clear any existing timeout before setting a new one
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                setShowNotificationModal(false);
                timeoutRef.current = null;
            }, 3000);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [errorMessage]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev > 1) {
                    return prev - 1;
                } else {
                    clearInterval(timer);
                    return 0;
                }
            });
        }, 1000);

        const handleResize = () => {
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            clearInterval(timer);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (!room || countdown > 0) {
        return (
            <GameContainer windowHeight={windowHeight}>
                <div style={{
                    textAlign: 'center',
                    color: 'white',
                    fontSize: '3rem',
                    transition: 'all 0.5s ease'
                }}>
                    {countdown > 0 ? countdown : 'Joining...'}
                </div>
            </GameContainer>
        );
    }
    return (
        <GameContainer windowHeight={windowHeight}>
            {showNotificationModal && <ErrorNotification category={errorCategory as string} prizeName={errorMessage as string}/>}
            <Actions windowHeight={windowHeight}/>
            <CalledNumbers/>
            <Ticket/>
            <PlayersList/>
        </GameContainer>
    );
};

export default Game;
